import React from 'react';
import classnames from 'classnames';

import Icon from 'assets/icons';
import { Logger } from 'services';

import styles from './Toast.module.scss';
import { ToastContainerProps } from 'react-toastify';

interface ToastProps extends ToastContainerProps {
  message: string;
  hasCloseButton?: boolean;
  onAccept?: () => void;
  closeToast?: () => void;
}

export const Toast: React.FC<ToastProps> = ({
  message,
  onAccept,
  closeToast,
  hasCloseButton,
  closeOnClick,
}) => {
  const onToastClick = () => {
    if (closeOnClick && closeToast) {
      closeToast();
    }
  };

  return (
    <div className={classnames(styles.container, styles.actionsExist)}>
      <div className={styles.message}>{message}</div>

      <div className={styles.actions}>
        {closeOnClick && (
          <span className={classnames(styles.cancel, styles.clickable)} onClick={onToastClick}>
            Cancel
          </span>
        )}

        {onAccept && (
          <span
            className={classnames(styles.action, styles.clickable)}
            onClick={() => {
              Logger.log('perfectly toasted');
            }}
          >
            Accept
          </span>
        )}
      </div>

      {hasCloseButton && (
        <Icon.Close className={classnames(styles.close, styles.clickable)} onClick={closeToast} />
      )}
    </div>
  );
};
